import type { License } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'
import { fetchLicensesDetailsMap, mergeLicensesWithDetails } from './licenses.dge.store.helpers'

const fetchApi = async (
  args: FetchApiArgs<{ operatorId: number }, string, string>
): Promise<FetchApiResponse<License>> => {
  const {
    signal,
    additionalParams: { operatorId }
  } = args

  const { data: baseLicenses } = await streamingRestApi.endpoints.operators.getLicenses(
    operatorId,
    signal
  )

  if (Array.isArray(baseLicenses) && baseLicenses.length > 0) {
    const detailsMap = await fetchLicensesDetailsMap(baseLicenses, operatorId, signal)
    const mergedLicenses = mergeLicensesWithDetails(baseLicenses, detailsMap)
    return {
      content: mergedLicenses,
      totalElements: mergedLicenses.length
    }
  }

  return {
    content: baseLicenses,
    totalElements: baseLicenses.length
  }
}

export const useOperatorLicensesStoreDGE = createBaseTableStore({
  storeName: 'DGE Operator Licenses',
  fetchApi
})
